<template>
  <div class="content-main">
    <HeaderBar :text="headerBar.text" :backgroundUrl="headerBar.backgroundUrl"></HeaderBar>

    <div class="container">
      <div class="welfare-content row">
        <div class="col-sm-12 col- welfare-list">
          <div class="col-sm-12 col-md-6 col-lg-4 item"
            v-for="(image, index) in modifiedImageSet"
            :key="index"
            @click="active(index)"
          >
            <img :src="image.path" :alt="image.name">
            <div class="content" :class="{active: image.isActive}">
              <transition name="fade">
                <p key="show" v-if="image.isActive">{{image.detail}}</p>
                <p key="no" v-else class="center" :class="{active: image.isActive}" >
                  <template v-if="!isMobile">
                    ({{ moreInfo }})
                  </template>
                </p>
              </transition>
              <h1 :class="{active: image.isActive}">{{image.name}}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  data () {
    return {
      isMobile: (window.innerWidth < 769)
    }
  },
  methods: {
    active: function (index) {
      this.imageSet[index].isActive = !this.imageSet[index].isActive
    }
  },
  computed: {
    modifiedImageSet: function () {
      var imageSet = this.imageSet
      imageSet.map(el => {
        el.path = `/${this.$staticPath}/${el.path}`
        return el
      })
      return imageSet
    }
  },
  props: ['headerBar', 'moreInfo', 'imageSet']
}
</script>

<style scoped>

  .content-main {
    padding-bottom: 60px 0;
  }

  .content-main > .container {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .welfare-content {
    padding: 0 45px;
  }

  .welfare-content .welfare-list {
    padding: 15px;
  }

  .welfare-list .item {
    padding: 10px;
    position: relative;
  }

  .welfare-list .item img{
    max-width: 100%;
  }

  .welfare-list .item .content {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    background-color: transparent;
    cursor: pointer;
  }

  .welfare-list .item .content:hover,
  .welfare-list .item .content.active {
     background-color: rgba(0, 0, 0, 0.6);
  }

  .item .content p{
    color: #FFA500;
    margin: 0;
    text-align: left;
    padding: 20px 10px 5px 10px;
    font-size: 15px;
    line-height: 1.3;
  }

  .item .content .center {
    white-space: nowrap;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: 0.6s;
  }

  .item .content:hover .center {
    opacity: 1;
    transition: 0.2s ease-out;
  }

  .item .content .center.active{
    opacity: 0;
    transition: 0.4s ease-out;
  }

  .item .content h1 {
    opacity: 0;
    font-size: 27px;
    position: absolute;
    right: 15px;
    bottom: 10px;
    margin: 0;
    line-height: 1;
    color: #FFA500;
    transform: translateX(-20%);
    transition: opacity 0.6s, transform 0.6s;
  }

  .item .content:hover h1, .item .content h1.active{
    transform: none;
    opacity: 1;
  }

  .fade-enter-active {
    transition: all 0.5s ease-in-out;
  }

  .fade-leave-active {
    transition: all 0.5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media screen and (max-width: 480px) {
    .welfare-content {
      padding: 0 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/DORM/Facilities.vue